import { formatQuantityMessage } from './quantityMessage'

/**
 * Resolves the "you may buy at most N" alert for a quantity that was lowered to
 * the customer's ceiling. See `formatQuantityMessage` for the rules.
 *
 * @param template The configured `texts.cart.maxQuantityMessage`, if any.
 * @param max The cap that was applied.
 * @returns The message to show, or `undefined` when there is none to show.
 */
export const formatMaxQuantityMessage = (
  template: string | undefined,
  max: number | undefined,
): string | undefined => formatQuantityMessage(template, 'max', max)

export default formatMaxQuantityMessage
